import { CSSProperties } from 'react';
import { ACCENT_BUTTON, COLORS, CONTENT_COLUMN, FONTS, META } from '../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  section: {
    ...CONTENT_COLUMN,
    position: 'relative',
    overflow: 'hidden',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '9rem 6vw 4rem',
  },
  content: {
    position: 'relative',
    zIndex: 1,
  },
  eyebrow: {
    ...META,
    fontSize: '0.75rem',
    color: COLORS.accent,
    marginBottom: '1.75rem',
  },
  headline: {
    fontFamily: FONTS.display,
    fontStretch: '125%',
    fontSize: 'clamp(2.5rem, 5.4vw, 4.5rem)',
    fontWeight: 600,
    lineHeight: 1.06,
    letterSpacing: '-0.01em',
    color: COLORS.text,
    maxWidth: '900px',
    marginBottom: '1.75rem',
  },
  sub: {
    color: COLORS.muted,
    fontSize: '1.125rem',
    maxWidth: '540px',
    lineHeight: 1.7,
    marginBottom: '2.5rem',
  },
  actions: {
    display: 'flex',
    gap: '0.9rem',
    flexWrap: 'wrap' as const,
  },
  btnPrimary: {
    ...ACCENT_BUTTON,
    padding: '0.85rem 1.9rem',
    fontSize: '0.9375rem',
    fontWeight: 500,
    fontFamily: FONTS.body,
    transition: 'background 0.15s',
  },
  btnGhost: {
    background: 'transparent',
    color: COLORS.text,
    border: `1px solid ${COLORS.border}`,
    padding: '0.85rem 1.9rem',
    borderRadius: 0,
    fontSize: '0.9375rem',
    fontWeight: 400,
    fontFamily: FONTS.body,
    cursor: 'pointer',
    transition: 'border-color 0.15s',
  },
  specStrip: {
    display: 'flex',
    flexWrap: 'wrap' as const,
    gap: '2.5rem',
    marginTop: '4.5rem',
    paddingTop: '1.5rem',
    borderTop: `1px solid ${COLORS.border}`,
  },
  specItem: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '0.6rem',
  },
  specIndex: {
    ...META,
    fontSize: '0.7rem',
    color: COLORS.accent,
  },
  specLabel: {
    ...META,
    fontSize: '0.7rem',
    color: COLORS.label,
  },
};
